module.exports = __webpack_public_path__ + "img/project_nlp_robot.b017465c.png";